// extracted by mini-css-extract-plugin
export default {"header":"section-header_header__M+c9y","title":"section-header_title__KDxGZ","subtitle":"section-header_subtitle__mOtV6","action":"section-header_action__RYAiT"};